const initialState = {
  requestingFetchCompanies: false,
  successfulFetchCompanies: false,
  errorFetchCompanies: false,
  companies: {},
  requestingCreateCompany: false,
  successfulCreateCompany: false,
  errorsCreateCompany: false,
  companyCreated: {},
  requestingReadCompany: false,
  successfulReadCompany: false,
  errorsReadCompany: false,
  company: null,
  requestingDeleteCompany: false,
  successfulDeleteCompany: false,
  errorsDeleteCompany: false,
  rowDeleted: null,
  requestingUpdateCompany: false,
  successfulUpdateCompany: false,
  errorsUpdateCompany: false,
  companyUpdated: {},
  requestingReadCompanyByUser: false,
  successfulReadCompanyByUser: false,
  errorsReadCompanyByUser: false,
  companyByUser: {},
  requestingFetchAllCompanies: false,
  successfulFetchAllCompanies: false,
  errorFetchAllCompanies: false,
  allCompanies: {},
  requestingFetchCompaniesByType: false,
  successfulFetchCompaniesByType: false,
  errorFetchCompaniesByType: false,
  requestingFetchCompaniesByWarehouse: false,
  successfulFetchCompaniesByWarehouse: false,
  errorFetchCompaniesByWarehouse: false,
  companiesbyWarehouse: null,
  clients: {},
  dspOperators: {},
  logisticsOperators: {},
  inventoryOperators: {},
  historicSenders: {},
  historicOperators: {},
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_COMPANIES_REQUESTING":
      return {
        ...state,
        requestingFetchCompanies: true,
        successfulFetchCompanies: false,
        errorsFetchCompanies: false,
      };
    case "FETCH_COMPANIES_SUCCESS":
      return {
        ...state,
        requestingFetchCompanies: false,
        successfulFetchCompanies: true,
        errorFetchCompanies: false,
        companies: action.value,
      };
    case "FETCH_COMPANIES_ERROR":
      return {
        ...state,
        requestingFetchCompanies: false,
        successfulFetchCompanies: false,
        errorFetchCompanies: true,
      };
    case "CREATE_COMPANY_REQUESTING":
      return {
        ...state,
        requestingCreateCompany: true,
        successfulCreateCompany: false,
        errorsCreateCompany: false,
      };
    case "CREATE_COMPANY_SUCCESS":
      return {
        ...state,
        requestingCreateCompany: false,
        successfulCreateCompany: true,
        errorsCreateCompany: false,
        companyCreated: action.value,
      };
    case "CREATE_COMPANY_ERROR":
      return {
        ...state,
        requestingCreateCompany: false,
        successfulCreateCompany: false,
        errorsCreateCompany: true,
      };
    case "READ_COMPANY_REQUESTING":
      return {
        ...state,
        requestingReadCompany: true,
        successfulReadCompany: false,
        errorsReadCompany: false,
      };
    case "READ_COMPANY_SUCCESS":
      return {
        ...state,
        requestingReadCompany: false,
        successfulReadCompany: true,
        errorsReadCompany: false,
        company: action.value,
      };
    case "READ_COMPANY_ERROR":
      return {
        ...state,
        requestingReadCompany: false,
        successfulReadCompany: false,
        errorsReadCompany: true,
      };
    case "DELETE_COMPANY_REQUESTING":
      return {
        ...state,
        requestingDeleteCompany: true,
        successfulDeleteCompany: false,
        errorsDeleteCompany: false,
      };
    case "DELETE_COMPANY_SUCCESS":
      return {
        ...state,
        requestingDeleteCompany: false,
        successfulDeleteCompany: true,
        errorsDeleteCompany: false,
        rowDeleted: action.value,
      };
    case "DELETE_COMPANY_ERROR":
      return {
        ...state,
        requestingDeleteCompany: false,
        successfulDeleteCompany: false,
        errorsDeleteCompany: true,
      };
    case "UPDATE_COMPANY_REQUESTING":
      return {
        ...state,
        requestingUpdateCompany: true,
        successfulUpdateCompany: false,
        errorsUpdateCompany: false,
      };
    case "UPDATE_COMPANY_SUCCESS":
      return {
        ...state,
        requestingUpdateCompany: false,
        successfulUpdateCompany: true,
        errorsUpdateCompany: false,
        companyUpdated: action.value,
      };
    case "UPDATE_COMPANY_ERROR":
      return {
        ...state,
        requestingUpdateCompany: false,
        successfulUpdateCompany: false,
        errorsUpdateCompany: true,
      };
    case "READBYUSER_COMPANY_REQUESTING":
      return {
        ...state,
        requestingReadCompanyByUser: true,
        successfulReadCompanyByUser: false,
        errorsReadCompanyByUser: false,
      };
    case "READBYUSER_COMPANY_SUCCESS":
      return {
        ...state,
        errorsReadCompanyByUser: false,
        requestingReadCompanyByUser: false,
        successfulReadCompanyByUser: true,
        companyByUser: action.value,
      };
    case "READBYUSER_COMPANY_ERROR":
      return {
        ...state,
        errorsReadCompanyByUser: true,
        requestingReadCompanyByUser: false,
        successfulReadCompanyByUser: false,
      };
    case "FETCH_ALLCOMPANIES_REQUESTING":
      return {
        ...state,
        requestingFetchAllCompanies: true,
        successfulFetchAllCompanies: false,
        errorsFetchAllCompanies: false,
      };
    case "FETCH_ALLCOMPANY_SUCCESS":
      return {
        ...state,
        errorsFetchAllCompanies: false,
        requestingFetchAllCompanies: false,
        successfulFetchAllCompanies: true,
        allCompanies: action.value,
      };
    case "FETCH_ALLCOMPANY_ERROR":
      return {
        ...state,
        errorsFetchAllCompanies: true,
        requestingFetchAllCompanies: false,
        successfulFetchAllCompanies: false,
      };
    case "FETCH_COMPANIESBYTYPE_REQUESTING":
      return {
        ...state,
        requestingFetchCompaniesByType: true,
        successfulFetchCompaniesByType: false,
        errorFetchCompaniesByType: false,
      };
    case "FETCH_COMPANYBYSHIPPER_SUCCESS":
      return {
        ...state,
        errorFetchCompaniesByType: false,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: true,
        clients: action.value,
      };
    case "FETCH_HISTORIC_SENDERS_SUCCESS":
      return {
        ...state,
        errorFetchCompaniesByType: false,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: true,
        historicSenders: action.value,
      };
    case "FETCH_COMPANIESBYDSP_SUCCESS":
      return {
        ...state,
        errorFetchCompaniesByType: false,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: true,
        dspOperators: action.value,
      };
    case "FETCH_COMPANYBYLOGISTICSOPERATOR_SUCCESS":
      return {
        ...state,
        errorFetchCompaniesByType: false,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: true,
        logisticsOperators: action.value,
        loading: false,
        error: null
      };
    case "FETCH_HISTORIC_OPERATORS_SUCCESS":
      return {
        ...state,
        errorFetchCompaniesByType: false,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: true,
        historicOperators: action.value,
        loading: false,
        error: null
      };
    case "FETCH_COMPANYBYINVENTORYOPERATOR_SUCCESS":
      return {
        ...state,
        errorFetchCompaniesByType: false,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: true,
        inventoryOperators: action.value,
      };
    case "FETCH_COMPANY_ERROR":
      return {
        ...state,
        errorFetchCompaniesByType: true,
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: false,
      };
    case "RESET_COMPANY_FORM":
      return {
        ...state,
        requestingCreateCompany: false,
        successfulCreateCompany: false,
        errorsCreateCompany: false,
        companyCreated: null,
        requestingReadCompany: false,
        successfulReadCompany: false,
        errorsReadCompany: false,
        company: null,
        requestingDeleteCompany: false,
        successfulDeleteCompany: false,
        errorsDeleteCompany: false,
        rowDeleted: null,
        requestingUpdateCompany: false,
        successfulUpdateCompany: false,
        errorsUpdateCompany: false,
        companyUpdated: null,
        requestingReadCompanyByUser: false,
        successfulReadCompanyByUser: false,
        errorsReadCompanyByUser: false,
        companyByUser: null,
        requestingFetchAllCompanies: false,
        successfulFetchAllCompanies: false,
        errorFetchAllCompanies: false,
        allCompanies: {},
        requestingFetchCompaniesByType: false,
        successfulFetchCompaniesByType: false,
        errorFetchCompaniesByType: false,
        clients: {},
        operators: {},
      };
    case "DELETE_OPERATOR_BRANCH_REQUESTING":
      return {
        ...state,
        requestingDeleteOperatorBranch: true,
        successfulDeleteOperatorBranch: false,
        errorsDeleteOperatorBranch: false,
      };
    case "DELETE_OPERATOR_BRANCH_SUCCESS":
      return {
        ...state,
        requestingDeleteOperatorBranch: false,
        successfulDeleteOperatorBranch: false,
        errorsDeleteOperatorBranch: true
      };
    case "DELETE_OPERATOR_BRANCH_ERROR":
      return {
        ...state,
        requestingDeleteOperatorBranch: true,
        successfulDeleteOperatorBranch: false,
        errorsDeleteOperatorBranch: false,
      };
    case "DELETE_OPERATOR_BRANCH_END":
      return {
        ...state,
        requestingDeleteOperatorBranch: false,
        successfulDeleteOperatorBranch: false,
        errorsDeleteOperatorBranch: false,
      };

    case "FETCH_COMPANYBYWAREHOUSE_REQUESTING":
      return {
        ...state,
        requestingFetchCompaniesByWarehouse: true,
        successfulFetchCompaniesByWarehouse: false,
        errorFetchCompaniesByWarehouse: false,
      };
    case "FETCH_COMPANIESBYWAREHOUSE_SUCCESS":
      return {
        ...state,
        requestingFetchCompaniesByWarehouse: false,
        successfulFetchCompaniesByWarehouse: true,
        errorFetchCompaniesByWarehouse: false,
        companiesbyWarehouse: action.value,
      };
    case "FETCH_COMPANYBYWAREHOUSE_ERROR":
      return {
        ...state,
        requestingFetchCompaniesByWarehouse: false,
        successfulFetchCompaniesByWarehouse: false,
        errorFetchCompaniesByWarehouse: true,
      };
    case "RESET_COMPANIESBYWAREHOUSE_SUCCESS":
      return {
        ...state,
        requestingFetchCompaniesByWarehouse: false,
        successfulFetchCompaniesByWarehouse: false,
        errorFetchCompaniesByWarehouse: false,
        companiesbyWarehouse: {},
      };

    case "RESET":
      return initialState;
    default:
      return state;
  }
};

export default companyReducer;
